import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Landmark, ArrowLeft, Phone, Mail, MapPin } from "lucide-react";

const PAGES = {
  privacy: { key: "privacy_policy", title: "Privacy Policy" },
  terms: { key: "terms", title: "Terms & Conditions" },
  disclaimer: { key: "disclaimer", title: "Disclaimer" },
  refund: { key: "refund_policy", title: "Refund & Cancellation Policy" },
  contact: { key: "__contact__", title: "Contact Us" },
};

export default function LegalPage() {
  const { slug } = useParams();
  const meta = PAGES[slug] || PAGES.privacy;
  const [company, setCompany] = useState({});
  const [landing, setLanding] = useState({});

  useEffect(() => {
    api.get("/public/company").then((r) => setCompany(r.data || {})).catch(() => {});
    api.get("/public/landing").then((r) => setLanding(r.data || {})).catch(() => {});
    window.scrollTo(0, 0);
  }, [slug]);

  const brand = company.company_name || "Paisapaid";
  const content = company[meta.key];
  const fallbackDisclaimer = landing.disclaimer;

  return (
    <div className="app-bg min-h-screen">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-slate-950/80 border-b border-slate-800/70">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="h-9 w-9 rounded-lg bg-primary/15 flex items-center justify-center"><Landmark className="h-5 w-5 text-primary" /></span>
            <span className="font-heading font-extrabold text-lg">{brand}</span>
          </Link>
          <Link to="/" className="text-sm text-slate-300 hover:text-primary flex items-center gap-1.5"><ArrowLeft className="h-4 w-4" /> Home</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 py-12">
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold">{meta.title}</h1>

        {slug === "contact" ? (
          <div className="mt-8 space-y-4 text-slate-300">
            <p>किसी भी सवाल के लिए हमसे संपर्क करें:</p>
            <ul className="space-y-3">
              {company.phone && <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-primary" />{company.phone}</li>}
              {company.email && <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-primary" />{company.email}</li>}
              {company.address && <li className="flex items-start gap-3"><MapPin className="h-4 w-4 text-primary mt-0.5" />{company.address}</li>}
            </ul>
          </div>
        ) : content ? (
          <div className="mt-8 prose prose-invert max-w-none text-slate-300 whitespace-pre-wrap leading-relaxed">{content}</div>
        ) : (
          <div className="mt-8 text-slate-400 leading-relaxed">
            <p>{fallbackDisclaimer || "यह पेज जल्द ही update किया जाएगा।"}</p>
            {slug === "disclaimer" && (
              <ul className="mt-4 list-disc list-inside space-y-1.5 text-sm">
                <li>Loan approval lender की policies और eligibility पर निर्भर करता है।</li>
                <li>Product availability बदल सकती है।</li>
                <li>दी गई जानकारी बदलाव के अधीन है।</li>
                <li>{brand} किसी approval, disbursement, income या business result की guarantee नहीं देता।</li>
              </ul>
            )}
          </div>
        )}
      </main>
    </div>
  );
}
